"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tile = void 0;
exports.cleanupTileVideoElements = cleanupTileVideoElements;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _chime = require("@studio/chime");
var _Tile = require("./Tile.styled");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  var ref = (0, _react.useRef)();
  // Store current value in ref
  (0, _react.useEffect)(function () {
    ref.current = value;
  }, [value]); // Only re-run if value changes
  // Return previous value (happens before update in useEffect above)
  return ref.current;
}
var tileIdAttributeName = 'data-tile-id';
var Tile = exports.Tile = function Tile(_ref) {
  var type = _ref.type,
    tile = _ref.tile,
    tileId = _ref.tileId,
    meetingSession = _ref.meetingSession,
    onThumbnailReady = _ref.onThumbnailReady,
    _videoRefOverride = _ref._videoRefOverride;
  var videoRef = (0, _react.useRef)(null);
  var previousTileId = usePrevious(tileId);
  (0, _react.useEffect)(function () {
    var videoElement = _videoRefOverride || (videoRef === null || videoRef === void 0 ? void 0 : videoRef.current);
    if (!videoElement) return;
    videoElement.disablePictureInPicture = true;
    if (!meetingSession || typeof tileId !== 'number') return;
    var localTile = tile.localTile,
      boundVideoStream = tile.boundVideoStream;

    /**
     * When chime changes the local video input stream, it looks for the local tile, then changes the media stream associated
     * with that tile (unbinding and then rebinding the stream to the DOM element). But it only does this for 1 DOM element, the
     * `boundVideoElement` property in the VideoTileState. Since we often bind a tile to more than one `video` element,
     * we need to make sure that if the video stream has changed, we can update the video element to use the new stream.
     *
     */
    var hasSameVideoStream = videoElement && boundVideoStream === (videoElement === null || videoElement === void 0 ? void 0 : videoElement.srcObject);
    if (onThumbnailReady) {
      var onLoadedData = function onLoadedData() {
        setTimeout(function () {
          if (!hasSameVideoStream) {
            var canvas = document.createElement('canvas');
            var thumbWidth = 200,
              thumbHeight = 112;
            canvas.width = thumbWidth;
            canvas.height = thumbHeight;
            canvas.getContext('2d').drawImage(videoElement, 0, 0, thumbWidth, thumbHeight);
            onThumbnailReady(canvas.toDataURL('image/png'));
          }
        }, 1000);
        videoElement.removeEventListener('loadeddata', onLoadedData);
      };
      videoElement.addEventListener('loadeddata', onLoadedData);
    }
    if (!hasSameVideoStream && boundVideoStream) {
      try {
        (0, _chime.connectVideoStreamToVideoElement)(boundVideoStream, videoElement, localTile);
      } catch (e) {
        console.warn('Failed to connect video stream to video element');
      }
      return;
    }
    if (tileId === previousTileId) return;
    (0, _chime.bindVideoElement)(meetingSession, tileId, videoElement);

    // Added this cleanup function to address this issue related to Chrome 92
    // update: https://bugs.chromium.org/p/chromium/issues/detail?id=1232649
    return function () {
      return (0, _chime.disconnectVideoStreamFromVideoElement)(videoElement);
    };
  }, [tile, tileId, meetingSession, previousTileId, onThumbnailReady, _videoRefOverride]);
  var attrs = (0, _defineProperty2["default"])({}, tileIdAttributeName, tileId);
  return /*#__PURE__*/_react["default"].createElement(_Tile.StyledVideo, (0, _extends2["default"])({
    ref: videoRef,
    sourceType: type
  }, attrs));
};
Tile.propTypes = {
  tileId: _propTypes["default"].number,
  onThumbnailReady: _propTypes["default"].func,
  /** only use this props in jest test */
  _videoRefOverride: _propTypes["default"].object
};

/**
 * Utility method for cleaning up tiles so that we don't run into https://crbug.com/1144736#c27 (https://jira.cvent.com/browse/WEBINAR-23540)
 * @param {*} parentNode
 */
function cleanupTileVideoElements(parentNode) {
  var localTileParentId = 'local-tile-video-wrapper';
  var videoElements = parentNode.getElementsByTagName('video');
  [].slice.call(videoElements).forEach(function (el) {
    if (el.hasAttribute(tileIdAttributeName) && el.parentElement.id !== localTileParentId) {
      el.srcObject = null;
    }
  });
}